module.exports = __webpack_public_path__ + "img/koek.bc435f57.png";